export const EXTERNAL_POINT_OF_SALE = 'External Point of Sale'
export const WS_EXTERNAL_BOUTIQUE = 'WS-External Boutique'
export const WS_EXTERNAL_BOUTIQUE_ALT = 'WS_External_Boutique'

export const ABBREVIATION_MAISON = {
  CAR: 'CA',
  JLC: 'JL',
  VCA: 'VC',
  IWC: 'IW',
  PAN: 'PA',
  VAC: 'VA',
  RDU: 'RD',
  DUN: 'DU',
  PIA: 'PI',
  MTB: 'MB',
  CHL: 'CH',
  AAL: 'AA',
  ALS: 'LS',
  BEM: 'BM'
}

export const MAISON_TO_FULLNAME = {
  MTB: 'Montblanc',
  CHL: 'Chloe',
  DUN: 'Dunhill',
  RDU: 'Roger Dubuis',
  CAR: 'Cartier',
  JLC: 'Jaeger Le Coultre',
  VCA: 'Van Cleef & Arpels',
  IWC: 'International Watch Company',
  VAC: 'Vacheron Constantin',
  PAN: 'Panerai',
  PIA: 'Piaget',
  AAL: 'Alaia',
  ALS: 'A. Lange & Sohne',
  BEM: 'Baume Et Mercier'
}

export const CONTEXT_POV = {
  strap: 'hasStrap',
  ngcs: 'isNGCS',
  esfy: 'isESFY',
  clickncollect: 'isClickNCollect',
  pickup: 'isFastPickup',
  boutiqueinvitation: 'isBoutiqueInvitation',
  productdiscovery: 'isProductDiscovery',
  campaign: 'isCampaign'
}

export const NOTIFICATION_CHANNELS = {
  email: 'Email',
  sms: 'SMS'
}

export const KOREAN_CONSENTS = [
  {
    name: 'PI_Consent_CollectPersonalInformation',
    required: true,
    options: [
      {
        label: 'PI_Consent_Agree',
        value: true,
        type: 'radio',
        required: true
      },
      {
        label: 'PI_Consent_Disagree',
        value: false,
        type: 'radio'
      }
    ],
    seeMore: true,
    seeMoreLabels: {
      header: 'PI_SeeMore1_Header',
      col1Title: 'PI_SeeMore1_Table_col1Title',
      col1Content: 'PI_SeeMore1_Table_col1Content',
      col2Title: 'PI_SeeMore1_Table_col2Title',
      col2Content: 'PI_SeeMore1_Table_col2Content',
      col3Title: 'PI_SeeMore1_Table_col3Title',
      col3Content: 'PI_SeeMore1_Table_col3Content',
      footer: 'PI_SeeMore1_Footer'
    }
  },
  {
    name: 'PI_Consent_SendMarketingCom',
    required: false,
    options: [
      {
        label: 'PI_Consent_Agree',
        value: true,
        type: 'radio'
      },
      {
        label: 'PI_Consent_Disagree',
        value: false,
        type: 'radio'
      }
    ],
    seeMore: true,
    seeMoreLabels: {
      header: 'PI_SeeMore2_Header',
      col1Title: 'PI_SeeMore2_Table_col1Title',
      col1Content: 'PI_SeeMore2_Table_col1Content',
      col2Title: 'PI_SeeMore2_Table_col2Title',
      col2Content: 'PI_SeeMore2_Table_col2Content',
      col3Title: 'PI_SeeMore2_Table_col3Title',
      col3Content: 'PI_SeeMore2_Table_col3Content',
      footer: 'PI_SeeMore2_Footer'
    }
  },
  {
    name: 'PI_Consent_ConfirmAge',
    required: true,
    seeMore: false,
    options: [
      {
        label: 'PI_Consent_ConfirmAge_description',
        value: true,
        type: 'checkbox'
      }
    ]
  }
]
